import { BaseButton } from '@/components/common/base-button';
import PlaceHolder from '@/components/icons/shop/PlaceHolder';
import type { PoiContent } from '@/services/dto';
import { useConfigStore } from '@/stores';
import { getPoiListImageUrlFromContent } from '@/utils/poi/poiImage';
import clsx from 'clsx';
import { useMemo } from 'react';
import styles from './styles.module.scss';

type Props = {
    poiList?: PoiContent[];
    onSelectPoi?: (poi: PoiContent) => void;
    selectedPoiId?: string;
    tabOrders?: number[];
    alignLeft?: boolean;
};

export const PoiListCarousel = ({ poiList, onSelectPoi, selectedPoiId, tabOrders = [], alignLeft = false }: Props) => {
    const {
        config: {
            ui: { language },
        },
    } = useConfigStore();
    const isShowPoiList = useMemo(() => {
        if (!Array.isArray(poiList) || !poiList?.length) {
            return false;
        }
        return true;
    }, [poiList]);

    if (!isShowPoiList) {
        return null;
    }

    return (
        <div
            className={clsx(styles['poi-list-carousel'], 'scrollbar-hide', {
                [styles['poi-list-carousel--align-left']]: alignLeft,
            })}
        >
            {Array.isArray(poiList) &&
                poiList?.map((poi, index) => {
                    const imageUrl = getPoiListImageUrlFromContent(poi, language);
                    const hasTabOrders = tabOrders.length > 0;
                    const tabOrder = tabOrders[index];

                    return (
                        <BaseButton
                            data-modal-region={hasTabOrders || index === 0}
                            tabIndex={hasTabOrders ? tabOrder : 10}
                            {...(hasTabOrders ? { 'data-modal-region-order': tabOrder } : {})}
                            data-interactive
                            key={poi?.id}
                            onClick={() => onSelectPoi?.(poi)}
                            className={clsx(styles['poi-list-carousel__item'], 'focus-border', {
                                [styles['poi-list-carousel__item--selected']]: selectedPoiId === poi?.id,
                            })}
                            aria-label={(poi?.name?.[language] ? poi?.name?.[language] : poi?.name?.['ko']) || ''}
                        >
                            <div className={clsx(styles['poi-list-carousel__image'])}>
                                {imageUrl ? (
                                    <img src={imageUrl} alt={poi?.name?.[language] ?? ''} />
                                ) : (
                                    <div className="h-full w-full">
                                        <PlaceHolder />
                                    </div>
                                )}
                            </div>
                            <div
                                className={clsx(styles['poi-list-carousel__name'], {
                                    [styles['poi-list-carousel__name--selected']]: selectedPoiId === poi?.id,
                                })}
                            >
                                {(poi?.name?.[language] ? poi?.name?.[language] : poi?.name?.['ko']) || ''}
                            </div>
                            {selectedPoiId !== poi?.id && <div className={clsx(styles['poi-list-carousel__mask'])}></div>}
                        </BaseButton>
                    );
                })}
        </div>
    );
};
